export default class Newsletter {
    constructor() {
        this.$form = $('.inf-form');
        this.$form.find('style').remove();
        //this.$form.find('h4').replaceWith(`<h2>${this.$form.find('h4').first().text()}</h2>`);
        this.$form.find("input[type='text']").addClass('form-control');
        this.$form.find("input[type='submit']").addClass('btn btn-primary').val('Envoyer');

        $('.inf-btn').css('display', 'none');
    }
}